import React from "react";

const Common = () => {
  return (
    <div className="">
      <p className="text-xl px-4 py-2 bg-orange-400 text-white font-semibold  rounded-md">
        Email sent successfully......
      </p>
    </div>
  );
};

export default Common;
